module.exports = __webpack_public_path__ + "img/underwriting.145dbd44.png";